
import SidebarShell from "@/components/SidebarShell/SidebarShell.vue";
import SidebarContext from "@/components/SidebarContext/SidebarContext.vue";
import SidebarUserFooter from "@/components/SidebarUserFooter/SidebarUserFooter.vue";
import brand_details from "@/data/brand_details";
import is_admin_user from "@/utils/auth_user";
import collapsed_sidebar_tooltip from "@/mixins/collapsed_sidebar_tooltip";

// IMPORT UTILITIES
import { get_user_profile } from "@/router";
const details = brand_details();
const default_portfolio_menu_item = "daily-gm-dashboard";

export default {
  name: "PortfolioSidebar",

  // REGISTER SHARED COMPONENTS
  components: ({
    SidebarShell,
    SidebarContext,
    SidebarUserFooter
  }),

  mixins: [collapsed_sidebar_tooltip],

  // PROPS PASSED FROM dashboard_one
  props: {
    tiles: Array,
    current_active_property: String,
    active_item: {
      type: String,
      default: default_portfolio_menu_item
    }
  },

  data() {
    return ({
      //Brand Information
      brand_name: details.name,
      brand_subtitle: details.subtitle,
      entity_name: details.sub_entity_name,
      details_subtitle: details.sub_entity_subtitle,

      // CONTEXT STATE
      selected_portfolio: "Mining Operations",
      local_active_property: null,
      active_drilldown_item: "safety",
      active_menu_item: default_portfolio_menu_item,
      dropdownOpen: false,
      show_collapsed_properties: false,

      // FOOTER DATA
      full_name: "Guest User",
      initials: "GU",
      is_admin: false,

      // BRAND LOGO
      short_logo: details.logo
    });
  },

  // COMPUTED VALUES
  computed: ({
    total_properties_count() {
      return (this.tiles || []).length;
    },

    portfolio_context_subtitle() {
      return `Mine Performance Snapshot`;
    },

    drilldownItems() {
      return (this.tiles || []).map((tile) => ({
        id: tile.id,
        label: tile.title,
        title: tile.title,
        is_live: tile.is_live,
        icon: "bi bi-diagram-3-fill"
      }));
    },

    menuItems() {
      return [
        { key: "daily-gm-dashboard", label: "Daily GM Dashboard", icon: "bi bi-calendar-day-fill" },
        { key: "weekly-dashboard", label: "Weekly Dashboard", icon: "bi bi-calendar-week-fill" },
        { key: "monthly-dashboard", label: "Monthly Dashboard", icon: "bi bi-calendar-month-fill" }
      ];
    }
  }),

  // LIFECYCLE
  mounted() {
    this.load_user_name();
      this.active_menu_item = this.active_item || default_portfolio_menu_item;

    if (this.current_active_property) {
      const selected_tile = this.tiles.find(t => t.title === this.current_active_property);
      this.local_active_property = selected_tile?.id || this.current_active_property;
      this.selected_portfolio = this.current_active_property;
    }
  },

  watch: {
    active_item(value) {
      this.active_menu_item = value || default_portfolio_menu_item;
    }
  },

  // METHODS
  methods: {
    /** FOOTER NAME / INITIALS */
    load_user_name() {
      const user = get_user_profile();
      let name = "Guest User";
      this.is_admin = is_admin_user(user);

      if (user && (user.first_name || user.last_name)) {
        name = `${user.first_name || ""} ${user.last_name || ""}`.trim();
      } else {
        const first = sessionStorage.getItem("first_name") || "";
        const last = sessionStorage.getItem("last_name") || "";
        name = `${first} ${last}`.trim() || "Guest User";
      }

      if (name === "Guest User" && user?.email) {
        name = user.email.split("@")[0];
      }

      const parts = name.split(" ");
      const initials = ((parts[0]?.[0] || "") + (parts[1]?.[0] || "")).toUpperCase();

      this.full_name = name;
      this.initials = initials || "GU";
    },

    /** CONTEXT DROPDOWN ACTIONS */
    toggleDropdown() {
      this.dropdownOpen = !this.dropdownOpen;
    },

    select_global_portfolio() {
      this.selected_portfolio = "Mining Operations";
      this.local_active_property = null;
      this.active_drilldown_item = "safety";
      this.active_menu_item = default_portfolio_menu_item;
      this.dropdownOpen = false;

      this.$emit("global-selected");
      this.$emit("global-menu-selected", default_portfolio_menu_item);
    },

    select_drilldown_item(item) {
      this.select_tile_directly(item);
    },

    select_tile_directly(tile) {
      this.selected_portfolio = tile.label || tile.title;
      this.local_active_property = tile.id;
      this.active_menu_item = default_portfolio_menu_item;
      this.dropdownOpen = false;

      this.$emit("tile-clicked", tile.id);
    },

    /** MENU SELECTION */
    select_menu_item(menuItem) {
      this.active_menu_item = menuItem;
      this.dropdownOpen = false;

      if (!this.local_active_property) {
        this.$emit("global-menu-selected", menuItem);
        return;
      }

      const tile = this.tiles.find(t => t.id === this.local_active_property);

      if (tile) {
        this.$emit("property-menu-selected", {
          menuItem,
          propertyId: tile.id,
          propertyName: tile.title
        });
      } else {
        this.$emit("global-menu-selected", menuItem);
      }
    },
    toggle_collapsed_properties() {
      this.show_collapsed_properties = !this.show_collapsed_properties;
    }

  }
};
